import styled from 'styled-components';

import { ReactComponent as Ayuda } from 'assets/images/ayuda.svg';
import { ReactComponent as Cambiar } from 'assets/images/cambiar.svg';
import { ReactComponent as Cancel } from 'assets/images/cancel.svg';
import { ReactComponent as Chevron } from 'assets/images/chevron-small.svg';
import { ReactComponent as CopyPaste } from 'assets/images/copy-paste.svg';
import { ReactComponent as Historial } from 'assets/images/historial.svg';
import { ReactComponent as Info } from 'assets/images/info-circle.svg';

export const Item = styled.li`
  color: #332927;
  border-bottom: 1px solid #dbdbdb;
  padding: 16px 0;

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
  &:first-child {
    border-top: 1px solid #dbdbdb;
  }
`;
export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const Icon = styled.div`
  margin-right: 6px;
  display: flex;
  align-items: center;
`;
export const Label = styled.div`
  color: #332927;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  cursor: pointer;
`;
export const Arrow = styled.div``;
export const Dot = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2px;
  width: 8px;
  height: 8px;
  background: #F4BF31;
  border-radius: 80px;
  margin: 0 1px;
  align-self: flex-start;
`;

export const Note = styled.div`
  background: #feecde;
  border-radius: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px;
  gap: 4px;
  color: #332927;
  margin-top: 10px;
`;

export const IconCopyPaste = styled(CopyPaste)`
  color: #332927;
  width: 24px;
  height: 24px;
`;
export const IconExchange = styled(Cambiar)`
  color: #332927;
  width: 20px;
  height: 20px;
`;
export const IconHistory = styled(Historial)`
  color: #332927;
  width: 20px;
  height: 20px;
`;
export const IconCancel = styled(Cancel)`
  color: #332927;
  width: 20px;
  height: 20px;
`;
export const IconHelp = styled(Ayuda)`
  color: #332927;
  width: 20px;
  height: 20px;
`;
export const IconChevron = styled(Chevron)`
  color: #332927;
  width: 16px;
  height: 16px;
`;
export const AirIcon = styled.img`
  height: 20px;
  max-width: 30px;
`;

export const IconInfo = styled(Info)`
  color: #ff6500;
  width: 18px;
  height: 18px;
`;
